import axios from 'axios'

export function transformObjectToSend(obj) {
    return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key]
        if (value !== undefined && value !== null) {
            acc.push({
                name: key,
                value: value === true ? 'TAK<br>\n' : `${value}<br>\n`,
            })
        }
        return acc
    }, [])
}
export function useForm() {
    const isSuccess = ref(false)
    const isError = ref(false)
    async function sendForms(dataPost) {
        const config = useRuntimeConfig()
        const apiLead = config.public.API_BASE_URL
        const graphqlQuery = {
            query: 'mutation sendLead($event_type: String!, $mail_title: String!, $fields: [InputLeadField]) {\n  sendLead(lead: {type: $event_type, name: $mail_title, fields: $fields})\n}\n',
            variables: {
                ...dataPost,
            },
        }

        try {
            const response = await axios.post(apiLead, graphqlQuery, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.data.sendLead) {
                isSuccess.value = true
            }
        } catch (error) {
            if (error) {
                isError.value = true
                console.error('Network or server error:', error)
            }
        }
    }
    return {
        isSuccess,
        isError,
        sendForms,
    }
}
